import "./style.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import OrderItem from "./OrderItem";
import useGetCollectionOrdersByFilter from "../../hooks/Order/useGetCollectionOrdersByFilter";
import Loader from "react-loader-spinner";

const DashboardRecentOrdersInbound = () => {
  const { user } = useSelector((state) => state.session);

  const collectionOrdersQuery = useGetCollectionOrdersByFilter(
    user.id,
    user.email,
    5,
  );
  const collectionOrders = collectionOrdersQuery?.data?.data || [];
  return (
    <div className="dashboard-recent-orders">
      <div className="tw-flex tw-flex-row xs:tw-flex-col tw-justify-between">
        <div className="tw-py-2 tw-pr-2 tw-flex tw-flex-col tw-w-6/12 xs:tw-w-4/5">
          <h3 className="tw-mt-3 xs:tw-text-base xs:tw-font-semibold">
            My Recent Orders
          </h3>
          <p className="tw-m-0 tw-text-gray-600 tw-font-light xs:tw-text-xs xs:tw-font-normal">
            Click on an order to see more details
          </p>
        </div>
        <div className="tw-flex xs:tw-flex-flex">
          <div className="tw-flex tw- tw-flex-col tab:tw-w-52 tw-w-64 tw-text-center tw-py-2 tw-pl-2 tw-self-end xs:tw-w-1/2">
            <Link
              to={{
                pathname: "/collection-orders",
              }}
              className="tw-py-2 tw-mt-3 tw-bg-tosca-blue tw-no-underline tw-cursor-pointer tw-text-base tw-rounded hover:tw-bg-tosca-blue-light hover:tw-text-gray-900 xs:tw-text-sm">
              Review History
            </Link>
          </div>

          <div className="tw-flex tw-flex-col tab:tw-w-52 tw-w-64 tw-text-center tw-py-2 tw-pl-2 tw-self-end xs:tw-w-1/2">
            <Link
              to={{
                pathname: "/collection-orders/new",
              }}
              className="tw-py-2 tw-mt-3 tw-bg-tosca-blue tw-no-underline tw-cursor-pointer tw-text-base tw-rounded hover:tw-bg-tosca-blue-light hover:tw-text-gray-900 xs:tw-text-sm">
              Create New Collection Order
            </Link>
          </div>
        </div>
      </div>

      {collectionOrdersQuery.isFetching ? (
        <div className="loader-container tw-flex tw-justify-center tw-mt-16">
          <Loader
            type="Oval"
            color="rgba(246,130,32,1)"
            height="50"
            width="50"
          />
        </div>
      ) : (
        <div className="tw-bg-white tw-p-4 xs:tw-overflow-x-auto tab:tw-overflow-x-auto">
          <div className="tw-min-w-[900px] tw-grid">
            <div className="tHeader tw-flex tw-justify-start tw-items-center tw-flex-row tw-bg-tosca-gray tw-py-5 tw-border-b tw-font-normal tw-text-xs tw-uppercase xs:tw-py-2">
              <div style={{ width: "40px", height: "40px" }} />
              <div
                className="header-item tw-text-left tw-px-2"
                style={{
                  minWidth: "120px",
                  maxWidth: "120px",
                  width: "120px",
                }}>
                Status
              </div>
              <div className="header-item order-date tw-text-left tw-px-2">
                Req Pick Up Date
              </div>
              <div className="header-item po-number tw-text-left tw-px-2">
                Ship From
              </div>
              <div className="header-item tw-text-left tw-px-2">BOL #</div>
              <div className="header-item tw-text-left tw-px-2">
                Carrier Name
              </div>
              <div className="header-item tw-text-left tw-px-2">
                Trailer Number#
              </div>
              <div className="header-item tw-text-left tw-px-2">RPC Size</div>
              <div className="header-item tw-text-left tw-px-2">Quantity</div>
            </div>
            {collectionOrders.slice(0, 5).map((order, i) =>
              (() => {
                const orderLines = order.orderLines || [];
                const rentalLine =
                  orderLines.find((line) => line?.issueType === "Rental") ||
                  orderLines[0];

                const displayContainerType = rentalLine?.itemId || "-";
                const displayQuantity = rentalLine?.quantity ?? "-";

                return (
                  <OrderItem
                    key={i}
                    order={order}
                    bgColor={i % 2 ? "tw-bg-orange-300" : ""}
                    displayContainerType={displayContainerType}
                    displayQuantity={displayQuantity}
                  />
                );
              })(),
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardRecentOrdersInbound;
